import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';
import { ReactComponent as ArrowIcon } from '../../../images/ArrowIcon.svg';
import { ReactComponent as DetailsIcon } from '../../../images/DetailsIcon.svg';
import styles from './Table2.module.css';
import ViewCodeModal from './ViewCodeModal';

export interface InnerTableProps {
  // Table header columns (used to create header cells)
  columns: string[];
  // Function to handle sorting when clicking a header cell
  handleSort: (column: string) => void;
  // Currently sorted column
  sortColumn: string;
  // Current sort direction: 'asc' or 'desc'
  sortDirection: 'asc' | 'desc';
  
  // Loading state flag
  loading: boolean;
  // Data to display in the table (each row is an object with keys matching column names)
  data: { [key: string]: any }[];

  // Ref for the dropdown element (for positioning or click outside handling)
  dropdownRef: React.RefObject<HTMLDivElement>;}

const InnerTable: React.FC<InnerTableProps> = ({
  columns,
  
  handleSort,
  sortColumn,
  sortDirection,
  
  loading,
  data,
  dropdownRef,
  //later change some things, fetch data here, and pass id of book, when i have end point
}) => {
    const [modalRowIndex, setModalRowIndex] = useState<number | null>(null);
    const [dropdownOpen, setDropdownOpen] = useState<number | null>(null);
    
    const toggleDropdown = (index: number) => {
        setDropdownOpen(dropdownOpen === index ? null : index);
    };
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
          if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
            setDropdownOpen(null);
          }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
      }, []);
      
return (
    <div className={`${styles.innertable} ${styles.expandedContent}`}>
      {/* Table Header */}
      <div
        className={styles.innerTableHeader}
        style={{ gridTemplateColumns: `repeat(${columns?.length}, 1fr)` }}
      >
        {columns.map((column, index) => (
          <div
            key={index}
            className={styles.innerTableHeaderCell}
            onClick={() => handleSort(column)}
          >
            {column !== 'Book Cover' &&
              column !== 'Logo' &&
              column !== 'Active Icon' &&
              column !== 'Default Icon' && (
                // <ArrowIcon
                //   className={`${styles.arrowIcon} ${
                //     sortColumn === column
                //       ? sortDirection === 'asc'
                //         ? styles.asc
                //         : styles.desc
                //       : ''
                //   }`}
                // />
                <></>
              )}
            {column}
          </div>
        ))}
      </div>

      {/* Table Body */}
      <div className={styles.innerTableBody}>
        {loading ? (
          <div className="text-center mt-8">
            <CircularProgress />
          </div>
        ) : data?.length > 0 && Array.isArray(data) ? (
          data?.map((row, rowIndex) => (
            <React.Fragment key={rowIndex}>
              {/* Row */}
              <div
                className={`${styles.innerTableRow} ${styles.expandedRow }`}
 
              >
                {columns.map((column, colIndex) => (
                  <div key={colIndex} className={styles.innerTableCell}>
                    {['Book'].includes(column)?
                        <div className={styles.bookColumn}>  
                            <div className="h-[100%] w-[56px] rounded-[5px] relative min-h-[100%] group flex items-center justify-center overflow-hidden bg-gray-100">
                                {/* Blurred background */}
                                <div className='absolute inset-0 z-0'>
                                    <img 
                                        src={row[column]||""} 
                                        alt={"book cover"} 
                                        className='w-full h-full object-cover blur-[4px]' 
                                    />
                                </div>

                                {/* Main image */}
                                <img 
                                    src={row[column]||""} 
                                    alt={"book image"} 
                                    className='z-10 max-h-[98%] max-w-[98%] object-contain' 
                                />
                            </div>
                            {row["BookTitle"] || <i>null</i>}
                        </div>
                    : colIndex !== columns.length - 1 ? (
                      <p
                        title={row[column] || 'null'}
                        className={styles.innerSpanStyle}
                      >
                        {row[column] || <i>null</i>}
                      </p>
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          paddingRight: '32px',
                          height:'100%',
                        }}
                      >
                            <p>{"$" + row[column] || <i>null</i>}</p>

                        <div className="relative">
                          <div ref={dropdownRef} className={styles.detailsIcon}>
                            <DetailsIcon
                              className={`${styles.detailsIcon} ${styles.threeDots}`}
                              onMouseDown={(event) => {
                                event.stopPropagation();
                                toggleDropdown(rowIndex);
                              }}
                            />
                          </div>
                          {dropdownOpen === rowIndex && (
                            <div className={styles.dropdownMenu}>
                              <div
                                className={styles.dropdownItem}
                                onMouseDown={(event) => {
                                  event.stopPropagation();
                                  setModalRowIndex(rowIndex);
                                }}
                              >
                                View Codes
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </React.Fragment>
          ))
        ) : (
          <div className="text-center mt-8">
            <h1>No Data Found</h1>
          </div>
        )}
      </div>
      {modalRowIndex !== null && (
        <ViewCodeModal
          codes={data[modalRowIndex].AccessCodes}
          show={true}
          onClose={() => setModalRowIndex(null)}
        />
      )}
    </div>
  );
};

export default InnerTable;
